import { render, staticRenderFns } from "./newpwd.vue?vue&type=template&id=75eda9a3&scoped=true&"
import script from "./newpwd.vue?vue&type=script&lang=js&"
export * from "./newpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eda9a3",
  null
  
)

export default component.exports